import { TYPE_PAGE_LIMIT } from 'constants/search'
import { SORTBY_VERTICAL_CRUISE } from 'constants/offerList'
import Places from './places'
import type { FixedPositionCruiseOfferId } from 'lib/cruises/insertFixedPositionCruiseOfferIds'
import { type IntlShape, defineMessages } from 'react-intl'

export const CRUISE_LOCATION_SEARCH_TYPEAHEAD_TYPES: Array<App.SearchPlaceType> = [
  'city',
  'colloquial_area',
  'continent',
  'country',
  'high_level_region',
  'multi_city_vicinity',
  'province_state',
]
export const CRUISE_DEPARTURE_SEARCH_TYPEAHEAD_TYPES: Array<App.SearchPlaceType> = ['city']
export const CRUISE_DESTINATION_SEARCH_TYPES: Array<App.SearchType> = ['destination']
export const CRUISE_DEPARTURE_SEARCH_TYPES: Array<App.SearchType> = ['destination']
export const CRUISE_SEARCH_HERO_IMAGE_ID_DESKTOP = 'xwa3kj2zjknsv7nbgctk'
export const CRUISE_SEARCH_HERO_IMAGE_ID_MOBILE = '6c530tmlxnsjyek4eksy'
export const CRUISE_DEALS_LIST_PAGE_HERO_IMAGE_ID = 'acee87eb-2922-4881-9799-3658cc046dcb'
export const CRUISE_DEALS_PAGE_SIZE = 10
export const CRUISE_OFFER_TYPES: Array<App.OfferType> = ['cruise']

// Cruise bundle hotel items
export const CRUISE_BUNDLE_HOTEL_ITEM_TYPES = new Set(['PRE_ACCOMMODATION', 'POST_ACCOMMODATION'])

// Image corner labels
export const CRUISE_FAMILY_PRICING_LABEL = 'exclusive-family-pricing'
export const CRUISE_SPECIAL_OFFER_LABEL = 'special-offer'
export const CRUISE_OFFER_COUNTDOWN_LABEL = 'offer-countdown'
// End of 20 October AEDT
export const CRUISE_OFFER_COUNTDOWN_END_DATE = '2026-10-20T12:59:59Z'
export const CRUISE_BUNDLE_HOTEL_LABEL = 'cruise-bundle-hotel'
export const CRUISE_BUNDLE_FLIGHT_CREDITS_LABEL = 'cruise-bundle-flight-credits'
export const CRUISE_BUNDLE_HOTEL_FLIGHT_CREDITS_LABEL = 'cruise-bundle-hotel-flight-credits'

export const CRUISE_SESSION_EXPIRATION_TIME_IN_MINUTES = 15
export const MAX_CRUISE_CABIN_LIMIT = 6
export const CRUISE_SEARCH_HERO_VIDEO_URL = 'https://player.vimeo.com/progressive_redirect/playback/796859202/rendition/1080p/file.mp4?loc=external&signature=140b579e292110b350a75b3a823ec915e644a3696c6229cb8d41347b6d8fd9c1'

export const UTM_CAMPAIGN_CRUISE_E2E_FLOW = 'cruise-e2e-flow'

export const CRUISE_OFFER_TYPE: App.Cruises.CruiseOfferType = 'cruise'
export const CRUISE_FLASH_OFFER_TYPE: App.Cruises.CruiseFlashOfferType = 'cruise_tour'
export const CRUISE_FLASH_OFFER_V1_TYPE: App.Cruises.CruiseFlashOfferV1Type = 'tour'
export const CRUISE_LEGACY_OFFER_HOTEL_TYPE: App.Cruises.CruiseLegacyOfferHotelType = 'hotel'

// Only add offers here when they do not satisfy CRUISE_UNIFIED_FILTERS, such as cruise holiday type
// with a cruise-compatible offer type, and therefore cannot be returned by search.
// Search-eligible cruise offers should be ordered via Admin Portal: /curation/offer-list-order.
export const CRUISE_TOP_OFFER_FIXED_POSITION_IDS: Array<FixedPositionCruiseOfferId> = [
  {
    id: 'tour-cf6243b5-238e-4bb4-93b9-696a29c9fff0',
    position: 6,
  },
]

export enum CruiseSectionTabValues {
  DATES_PRICING = 'DATES_PRICING',
  ITINERARY = 'ITINERARY',
  ABOUT_SHIP = 'ABOUT_SHIP',
  FAQ = 'FAQ',
  FINE_PRINT = 'FINE_PRINT',
}

export enum CruiseContentSections {
  GALLERY = 'gallery',
  OVERVIEW = 'overview',
  ITINERARY = 'itinerary',
  ABOUT_THE_SHIP = 'about-the-ship',
  // INCLUSIONS = 'inclusions',
  DEPARTURES = 'dates-and-pricing',
  DECKS_AND_CABINS = 'decks-and-cabins',
  FINE_PRINT = 'things-to-know',
  FAQ = 'frequently-asked-questions',
}

export enum CruiseType {
  OCEAN = 'OCEAN',
  RIVER = 'RIVER',
}

export enum CruiseTravellerType {
  ROMANTIC = 'romantic',
  FAMILY = 'family',
  SINGLES = 'singles',
}

export enum CruiseTravellerSearchType {
  ROMANTIC = 'ROMANTIC',
  FAMILY = 'FAMILY',
  SINGLE = 'SINGLE',
}

export enum CruiseTypeFilter {
  EXPEDITION = 'EXPEDITION',
  LUXURY = 'LUXURY',
}

/**
 * Localised labels for cruise type filter options.
 * Slugs (EXPEDITION, LUXURY, OCEAN, RIVER) are API matching keys and are not localised.
 */
export const cruiseTypeFilterMessages = defineMessages({
  expedition: {
    id: '9hyNrQkqNqCXy36Kw_3y',
    defaultMessage: 'Expedition',
    description: 'Cruise type filter option for expedition cruises in cruise search filters',
  },
  luxury: {
    id: '8MILIjmh4NVS07fYqLPK',
    defaultMessage: 'Luxury',
    description: 'Cruise type filter option for luxury cruises in cruise search filters',
  },
  ocean: {
    id: 'OrBf-MAwgf0EKpApq4Gq',
    defaultMessage: 'Ocean',
    description: 'Cruise type filter option for ocean cruises in cruise search filters',
  },
  river: {
    id: '3orb5th_D1qt93ZO2-V0',
    defaultMessage: 'River',
    description: 'Cruise type filter option for river cruises in cruise search filters',
  },
})

/**
 * Localised labels for svc-cruise traveller type filters.
 * Enum slugs (romantic, family, singles) are API matching keys and are not localised.
 */
export const cruiseTravellerTypeMessages = defineMessages({
  romantic: {
    id: 'wOwhXmxR26X9Pil0LDOv',
    defaultMessage: 'Romantic',
    description: 'Traveller type filter option for romantic cruises in cruise search filters',
  },
  family: {
    id: 'b_29oiECh-QhhsRnDuKS',
    defaultMessage: 'Family & group',
    description: 'Traveller type filter option for family and group cruises in cruise search filters',
  },
  singles: {
    id: 'iz0fiKdVfksAWBH3f290',
    defaultMessage: 'Singles',
    description: 'Traveller type filter option for solo travellers in cruise search filters',
  },
})

/**
 * Localised labels for cruise cabin categories shown in search and offer UI.
 */
export const cruiseCabinCategoryMessages = defineMessages({
  inside: {
    id: 'dP5SBpYTiHJM8qoNcbG1',
    defaultMessage: 'Inside',
    description: 'Cruise cabin type label for inside cabins in search filters and cabin selection',
  },
  oceanview: {
    id: 'oFZejcnGLNDbKiZNTED3',
    defaultMessage: 'Oceanview',
    description: 'Cruise cabin type label for oceanview cabins in search filters and cabin selection',
  },
  window: {
    id: '_1r-SSkOV2jY4rBj8TG6',
    defaultMessage: 'Window',
    description: 'Cruise cabin type label for window cabins where shown separately from full oceanview',
  },
  balcony: {
    id: 'qi3xPZY-i04mnMod7pL5',
    defaultMessage: 'Balcony',
    description: 'Cruise cabin type label for balcony cabins in search filters and cabin selection',
  },
  suite: {
    id: 'NykjyKOOj9ZcCTmxnLrC',
    defaultMessage: 'Suite',
    description: 'Cruise cabin type label for suite cabins in search filters and cabin selection',
  },
  oceanviewOrWindow: {
    id: 'mKXvvvoFCvipozxdmC8Z',
    defaultMessage: 'Oceanview / Window',
    description: 'Cruise cabin combined label for oceanview or window stateroom types in search UI',
  },
})

/**
 * Localised labels for svc-cruise lowest-price cabin category filters.
 * Values are sourced from defaultMessage so API filter matching stays stable.
 */
export const cruiseCabinCategoryFilterMessages = defineMessages({
  lowestInsidePrice: {
    id: 'OTJbmkySHI47CbiyZPPZ',
    defaultMessage: 'Lowest Inside Price',
    description: 'Cruise cabin category filter label for lowest inside cabin price',
  },
  lowestOceanviewPrice: {
    id: 'R-BrpStNGDcYlU834SRG',
    defaultMessage: 'Lowest Oceanview Price',
    description: 'Cruise cabin category filter label for lowest oceanview cabin price',
  },
  lowestBalconyPrice: {
    id: 'C7Ug-0OrQ7ibW0UDzsUT',
    defaultMessage: 'Lowest Balcony Price',
    description: 'Cruise cabin category filter label for lowest balcony cabin price',
  },
  lowestSuitePrice: {
    id: 'xv-x0Uy0Uq5MOojFm_Up',
    defaultMessage: 'Lowest Suite Price',
    description: 'Cruise cabin category filter label for lowest suite cabin price',
  },
  lowestWindowPrice: {
    id: 'U-abT7Jb-uGAtF9hKKii',
    defaultMessage: 'Lowest Window Price',
    description: 'Cruise cabin category filter label for lowest window cabin price',
  },
})

export const cruiseSearchGlossaryMessages = defineMessages({
  oceanCruise: {
    id: 'TgX1wB57hr3VpcOvULKc',
    defaultMessage: 'Ocean cruise',
    description: 'High-level product filter or hero label for ocean-going cruise product vertical',
  },
  riverCruise: {
    id: 'ye0H19kHDMBo4H7wqaD9',
    defaultMessage: 'River cruise',
    description: 'High-level product filter or hero label for river cruise product vertical',
  },
  allCruiseLines: {
    id: 'Ta4_XJUPNJokupWv9Cd0',
    defaultMessage: 'All cruise lines',
    description: 'Filter or nav label to show inventory across all available cruise line partners',
  },
  allDeparturePorts: {
    id: 'O3x8Sw6qemzVdVkDS1f-',
    defaultMessage: 'All departure ports',
    description: 'Label for the default option showing all cruise departure ports',
  },
})

export const cruiseLineNameMessages = defineMessages({
  royalCaribbean: {
    id: 'xrF00kRTSrZZTcxagJhj',
    defaultMessage: 'Royal Caribbean',
    description: 'Display name for Royal Caribbean cruise line in cruise line logos and filters',
  },
  regentSevenSeas: {
    id: 'whh6MeMV9plLscbVqw4l',
    defaultMessage: 'Regent Seven Seas',
    description: 'Display name for Regent Seven Seas cruise line in cruise line logos and filters',
  },
})

/*
 * These values are cabin type keys used for API comparisons and price lookups; do not translate them.
 * Translate customer-facing cabin names with useCruiseCabinTypeLabels or formatCruiseCabinTypeLabel.
 */
export const CRUISE_CABIN_CATEGORY = {
  INSIDE: 'Inside',
  OCEANVIEW: 'Oceanview',
  WINDOW: 'Window',
  BALCONY: 'Balcony',
  SUITE: 'Suite',
} as const

export type CruiseCabinCategory = typeof CRUISE_CABIN_CATEGORY[keyof typeof CRUISE_CABIN_CATEGORY]

export const CRUISE_CABIN_CATEGORY_FILTER = {
  LOWEST_INSIDE_PRICE: cruiseCabinCategoryFilterMessages.lowestInsidePrice.defaultMessage,
  LOWEST_OCEANVIEW_PRICE: cruiseCabinCategoryFilterMessages.lowestOceanviewPrice.defaultMessage,
  LOWEST_BALCONY_PRICE: cruiseCabinCategoryFilterMessages.lowestBalconyPrice.defaultMessage,
  LOWEST_SUITE_PRICE: cruiseCabinCategoryFilterMessages.lowestSuitePrice.defaultMessage,
  LOWEST_WINDOW_PRICE: cruiseCabinCategoryFilterMessages.lowestWindowPrice.defaultMessage,
} as const

export type CruiseCabinCategoryFilter = typeof CRUISE_CABIN_CATEGORY_FILTER[keyof typeof CRUISE_CABIN_CATEGORY_FILTER]

export const CRUISE_DEPARTURE_PORT_LABEL = {
  ALL: cruiseSearchGlossaryMessages.allDeparturePorts.defaultMessage,
} as const

export const CRUISE_LINE_DISPLAY_NAME = {
  ROYAL_CARIBBEAN: cruiseLineNameMessages.royalCaribbean.defaultMessage,
  REGENT_SEVEN_SEAS: cruiseLineNameMessages.regentSevenSeas.defaultMessage,
} as const

const cruiseTravellerTypeMessageBySlug = {
  [CruiseTravellerType.ROMANTIC]: cruiseTravellerTypeMessages.romantic,
  [CruiseTravellerType.FAMILY]: cruiseTravellerTypeMessages.family,
  [CruiseTravellerType.SINGLES]: cruiseTravellerTypeMessages.singles,
} as const satisfies Record<CruiseTravellerType, (typeof cruiseTravellerTypeMessages)[keyof typeof cruiseTravellerTypeMessages]>

const cruiseTypeFilterMessageBySlug = {
  [CruiseTypeFilter.EXPEDITION]: cruiseTypeFilterMessages.expedition,
  [CruiseTypeFilter.LUXURY]: cruiseTypeFilterMessages.luxury,
} as const satisfies Record<CruiseTypeFilter, (typeof cruiseTypeFilterMessages)[keyof typeof cruiseTypeFilterMessages]>

export function formatCruiseTravellerTypeLabel(intl: IntlShape, travellerType?: string): string | undefined {
  if (!travellerType) return undefined

  const message = cruiseTravellerTypeMessageBySlug[travellerType as CruiseTravellerType]
  return message ? intl.formatMessage(message) : travellerType
}

export function formatCruiseTypeFilterLabel(intl: IntlShape, cruiseType?: string): string | undefined {
  if (!cruiseType) return undefined

  const message = cruiseTypeFilterMessageBySlug[cruiseType as CruiseTypeFilter]
  if (message) {
    return intl.formatMessage(message)
  }

  const normalizedType = cruiseType.toLowerCase()
  switch (normalizedType) {
    case 'ocean':
      return intl.formatMessage(cruiseTypeFilterMessages.ocean)
    case 'river':
      return intl.formatMessage(cruiseTypeFilterMessages.river)
    case 'expedition':
      return intl.formatMessage(cruiseTypeFilterMessages.expedition)
    case 'luxury':
      return intl.formatMessage(cruiseTypeFilterMessages.luxury)
    default:
      return cruiseType
  }
}

export function formatCruiseCabinTypeSlugLabel(intl: IntlShape, cabinType?: string): string | undefined {
  if (!cabinType) return undefined

  switch (cabinType.toLowerCase()) {
    case 'inside':
      return intl.formatMessage(cruiseCabinCategoryMessages.inside)
    case 'oceanview':
      return intl.formatMessage(cruiseCabinCategoryMessages.oceanview)
    case 'window':
      return intl.formatMessage(cruiseCabinCategoryMessages.window)
    case 'oceanview_window':
      return intl.formatMessage(cruiseCabinCategoryMessages.oceanviewOrWindow)
    case 'balcony':
      return intl.formatMessage(cruiseCabinCategoryMessages.balcony)
    case 'suite':
      return intl.formatMessage(cruiseCabinCategoryMessages.suite)
    default:
      return cabinType
  }
}

export const CRUISE_OFFER_DUE_DATE_DAY_THRESHOLD = 90

export const CABIN_CATEGORIES: Array<App.Cruises.CabinCategory> = [
  { category: CRUISE_CABIN_CATEGORY.INSIDE, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_INSIDE_PRICE, defaultImageId: '6cxshzr6hfv7a0p5v1a' },
  { category: CRUISE_CABIN_CATEGORY.OCEANVIEW, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_OCEANVIEW_PRICE, defaultImageId: 'k4k2dg9n17f9khvoj19' },
  { category: CRUISE_CABIN_CATEGORY.BALCONY, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_BALCONY_PRICE, defaultImageId: 'lx75o348zmq1w0tsz3nig' },
  { category: CRUISE_CABIN_CATEGORY.SUITE, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_SUITE_PRICE, defaultImageId: '812wqcsgf6ysfozdbngl' },
]

export const CABIN_CATEGORIES_RIVER: Array<App.Cruises.CabinCategory> = [
  { category: CRUISE_CABIN_CATEGORY.WINDOW, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_WINDOW_PRICE, defaultImageId: 'cdc07f17-2170-419d-a286-276c302436ea' },
  { category: CRUISE_CABIN_CATEGORY.BALCONY, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_BALCONY_PRICE, defaultImageId: 'lx75o348zmq1w0tsz3nig' },
  { category: CRUISE_CABIN_CATEGORY.SUITE, filter: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_SUITE_PRICE, defaultImageId: '812wqcsgf6ysfozdbngl' },
]

export type CABIN_CATEGORY_TYPE = 'inside' | 'oceanview' | 'balcony' | 'suite'

export const CABIN_CATEGORIES_SORT_ORDER: Array<CABIN_CATEGORY_TYPE> = ['inside', 'oceanview', 'balcony', 'suite']

export const CRUISE_MOCK_PRICES = [
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: 'GS',
    rateCode: 'T',
    adultFare: 2609.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: CRUISE_CABIN_CATEGORY.SUITE,
  },
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: 'OV',
    rateCode: 'T',
    adultFare: 1447.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: CRUISE_CABIN_CATEGORY.OCEANVIEW,
  },
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: '4C',
    rateCode: 'PB4',
    adultFare: 1459.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: CRUISE_CABIN_CATEGORY.BALCONY,
  },
  {
    marketName: 'Australia',
    currencyCode: 'AUD',
    categoryCode: '1A',
    rateCode: 'PB4',
    adultFare: 439.32,
    nccf: 153.68,
    isNccfIncluded: false,
    tax: 162.89,
    isTaxIncluded: false,
    cabinCategory: CRUISE_CABIN_CATEGORY.INSIDE,
    cabinPriceDesc: CRUISE_CABIN_CATEGORY_FILTER.LOWEST_INSIDE_PRICE,
  },
]

// TODO it will be replaced by API data
export const SEARCH_DEPARTURE_PORTS: Array<App.SearchItem> = [
  {
    searchType: 'destination',
    value: Places.Anywhere.id,
    format: {
      mainText: CRUISE_DEPARTURE_PORT_LABEL.ALL,
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_678c61ac5b4f91ca86e112fc50e63766',
    format: {
      mainText: 'Sydney',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_ce393994e8cf430867408678d1a5a9c8',
    format: {
      mainText: 'Singapore',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_af15ce7cbd279b1a769d85d1540a5073',
    format: {
      mainText: 'Barcelona',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_39c4c0a45681f21cead1b7004d1a67ce',
    format: {
      mainText: 'Seattle',
    },
  },
  {
    searchType: 'departurePort',
    value: 'le_342fdc93f26b8bb8fe3548a9188ea5d2',
    format: {
      mainText: 'Athens',
    },
  },
]

export const CruiseSearchFilterKeys = [
  'cruiseShips',
  'promotions',
  'isLuxExclusivePromotion',
  'isSpecialOffers',
  'isLuxPlus',
  'hasLuxPlusPrice',
  'campaigns',
  'price.min',
  'price.max',
  'cruiseTypes',
  'travellerTypes',
  'cabinTypes',
]

export const LANDING_PAGE_AVAILABLE = [
  'RCC',
  'HAL',
  'CEL',
  'POA',
  'SRX',
  'PCL',
  'MSC',
]

export const CRUISE_UNIFIED_FILTERS: App.OfferListFilters = {
  holidayTypes: ['Cruises'],
  offerTypes: [
    CRUISE_OFFER_TYPE,
    CRUISE_FLASH_OFFER_TYPE,
    CRUISE_FLASH_OFFER_V1_TYPE,
    CRUISE_LEGACY_OFFER_HOTEL_TYPE,
  ],
  sortBy: SORTBY_VERTICAL_CRUISE,
  limit: TYPE_PAGE_LIMIT,
  offerSource: 'cruises',
}

export const CRUISE_BANK_UNIFIED_FILTERS: App.OfferListFilters = {
  offerTypes: [CRUISE_OFFER_TYPE],
  limit: TYPE_PAGE_LIMIT,
  destinationId: Places.Anywhere.id,
  offerSource: 'cruises',
  sortBy: SORTBY_VERTICAL_CRUISE,
}

export const CRUISE_BANK_OFFERS_FILTERS: App.OfferListFilters = {
  offerTypes: [CRUISE_OFFER_TYPE],
  limit: TYPE_PAGE_LIMIT,
  offerSource: 'cruises',
}

export const CRUISE_FLASH_OFFERS_FILTERS: App.OfferListFilters = {
  holidayTypes: ['Cruises'],
  offerTypes: [CRUISE_FLASH_OFFER_V1_TYPE, CRUISE_LEGACY_OFFER_HOTEL_TYPE],
  sortBy: SORTBY_VERTICAL_CRUISE,
  limit: TYPE_PAGE_LIMIT,
}

export const CRUISE_DESTINATION_PILLS = [
  { destinationName: 'Australia', destinationId: 'le_d3d9446802a44259755d38e6d163e820' },
  { destinationName: 'New Zealand', destinationId: 'le_9fc3d7152ba9336a670e36d0ed79bc43' },
  { destinationName: 'South Pacific', destinationId: 'le_a8697c7e6e7988b29a9de094b8d554cc' },
  { destinationName: 'Caribbean', destinationId: 'le_d7bce4d8dbac13945471c343c4973ba3' },
  { destinationName: 'Spain', destinationId: 'le_7e7757b1e12abcb736ab9a754ffb617a' },
  { destinationName: 'Greece', destinationId: 'le_735b90b4568125ed6c3f678819b6e058' },
  { destinationName: 'United States of America', urlName: 'United States of America', destinationId: 'le_757b505cfd34c64c85ca5b5690ee5293' },
]

// TODO: Remove the hardcoded vendor images - https://aussiecommerce.atlassian.net/browse/CRUZ-3104
export const CRUISE_LINE_CUSTOM_INFO = [
  { imageIdSm: 'en19l8ff1fhgec0k207', code: 'AZA' },
  { imageIdSm: 'x6b5w2dw9ihw8i5nu3kzt', code: 'CCL' },
  { imageIdSm: '29c4x6qlv72pdskxtuv', code: 'CEL' },
  { imageIdSm: 'fvzy8xe3zd1xtfiricim', code: 'CEX' },
  { imageIdSm: 'a4she3m3ztzpyvywg2un', code: 'CUN' },
  { imageIdSm: '0tewxh58wsfrur3gjj6', code: 'DCL' },
  { imageIdSm: 'bgrxlvu0d7eizy0cv06', code: 'EXJ' },
  { imageIdSm: '4s07r07b7tvwk8d8uav', code: 'HAL' },
  { imageIdSm: 'l3x4e3rmivugao9lp26m', code: 'MSC' },
  { imageIdSm: 'wyhk47lmzz096q98z6c', code: 'NCL' },
  { imageIdSm: 'tglbrhr4ue6puozki4k', code: 'OCL' },
  { imageIdSm: '4fp27ca9yvkuo9iajbc', code: 'PCL' },
  { imageIdSm: 'qjj296o519z21yc4o8yg', code: 'POA' },
  { imageIdSm: 'nenrq88hvwo2ouxdk8rf', code: 'RCC', name: CRUISE_LINE_DISPLAY_NAME.ROYAL_CARIBBEAN },
  { imageIdSm: 'p528tdrhgd8q68cf1c3', code: 'RDC', name: CRUISE_LINE_DISPLAY_NAME.REGENT_SEVEN_SEAS },
  { imageIdSm: 'xhdkxgy1xlumco336f', code: 'SBN' },
  { imageIdSm: 'i0mabf1aai5pnyzmvn', code: 'VVG' },
  { imageIdSm: 'xm94y5k2rfnvovolvq3w', code: 'SRX' },
  { imageIdSm: 'h0qxc9dhrldrkeyyf4be', code: 'HEX' },
  { imageIdSm: 'c228d2bc-9ee8-4d57-9152-b694d2d3ed25', code: 'CRS' },
  { imageIdSm: 'bd7adbfa-81ef-4a10-952b-931be6116cda', code: 'LCL' },
  { imageIdSm: 'cke43d5nf5kdem4fzop', code: 'VOC' },
  { imageIdSm: '2376536e-f6c5-4eff-a8ba-cde954d7d47c', code: 'URC' },
  { imageIdSm: 'dtjaokoqy9t4ziw25x8', code: 'AWW' },
  { imageIdSm: '29c4x6qlv72pdskxtuv', code: 'CER' },
  { imageIdSm: 'gmn0nhvd4q6pu05xguq', code: 'VRX' },
  { imageIdSm: 'gmn0nhvd4q6pu05xguq', code: 'VXP' },
  { imageIdSm: 'fr0av4qdh9nqefs6i7pc', code: 'HCL' },
  // flash offer cruise lines
  { imageIdSm: 'nenrq88hvwo2ouxdk8rf', code: 'Royal Caribbean International', name: CRUISE_LINE_DISPLAY_NAME.ROYAL_CARIBBEAN },
  { imageIdSm: 'w1zodchyrgyd4ri92f3f', code: 'Riverside Luxury Cruises' },
  { imageIdSm: '29c4x6qlv72pdskxtuv', code: 'Celebrity Cruises' },
  { imageIdSm: '2nsxgnhd0b0bm1k12a1v', code: 'Coral Expeditions' },
  { imageIdSm: 'ejvx4zaw3n52xaxjwcan', code: 'Heritage Expeditions' },
]

export const CRUISE_LINE_INFO = {
  AWW: {
    dealPageImageId: 'rke2ktooi9zrhomuofb',
    dealPageColour: '#B34E3C',
    finePrintLink: 'https://www.amawaterways.au/terms-conditions',
    onlineCheckinLink: 'http://www.amawaterways.com/check-in',
  },
  AZA: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#2A758C',
    finePrintLink: 'https://www.azamara.com/au/booked-guests/before-you-board/payment-cancellation',
    onlineCheckinLink: 'https://seaware.azamara.com/touchb2c/#/booking-search-route',
  },
  CCL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#3A4EA9',
    finePrintLink: 'https://www.carnival.com/about-carnival/legal-notice/termsandconditions',
    onlineCheckinLink: 'https://www.carnival.com/profilemanagement/accounts/register',
  },
  CEL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#0B3A5F',
    finePrintLink: 'https://www.celebritycruises.com/guest-terms/',
    refundPolicyLink: 'https://www.celebritycruises.com/int/faqs/cancellation-policy',
    onlineCheckinLink: 'https://www.celebritycruises.com/account/signin',
  },
  CEX: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#23305C',
    finePrintLink: 'https://luxuryescapes.com/au/booking-policies#cruises',
  },
  CRS: {
    dealPageImageId: '2l3ns8o8pqd81y7b7o6b',
    dealPageColour: '#0B8F97',
    finePrintLink: 'https://www.crystalcruises.com/legal/booking-terms-conditions',
  },
  CUN: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#843A46',
    finePrintLink: 'https://www.cunard.com/content/dam/cunard/marketing-assets/pdf/booking-condition-pdf/22052_Cunard%20Brochure%202023-24_Booking%20Conditions_DPS.pdf',
    onlineCheckinLink: 'https://my.cunard.com/en-au/mycruise/login',
  },
  DCL: {
    dealPageImageId: 'uqsst6n78qh6cm53fag',
    dealPageColour: '#A65153',
    finePrintLink: 'https://disneycruise.disney.go.com/contracts-terms-safety/terms-conditions/australia-new-zealand/',
    onlineCheckinLink: 'https://disneycruise.disney.go.com/featured/navigator-app/',
  },
  EXJ: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#856856',
    finePrintLink: 'https://explorajourneys.com/au/en/legal/booking-terms-and-conditions',
    onlineCheckinLink: 'https://explorajourneys.com/au/en',
  },
  HAL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#133D6C',
    finePrintLink: 'https://www.hollandamerica.com/en/legal-privacy/cruise-contract',
    onlineCheckinLink: 'https://www.hollandamerica.com/en_US/log-in/sso-log-in.html?login=olci',
  },
  HCL: {
    dealPageImageId: 'fr0av4qdh9nqefs6i7pc',
    dealPageColour: '#C8102E',
    finePrintLink: 'https://www.hurtigruten.com/en-au/help/further-information/general-terms-and-conditions',
    refundPolicyLink: 'https://www.hurtigruten.com/en-au/help/refunds-cancellations',
  },
  LCL: {
    dealPageImageId: 'ocgyxhd8ie8s5fbi6qrq',
    dealPageColour: '#022572',
    finePrintLink: 'https://celestyal.com/terms-and-conditions/booking-conditions',
    onlineCheckinLink: 'https://sale.celestyal.com/touchclst/#/booking-search-route',
  },
  MSC: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#091330',
    finePrintLink: 'https://www.msccruises.com.au/terms-conditions',
    onlineCheckinLink: 'https://www.msccruises.com.au/en-au/Web-Check-in/Web-Check-In.aspx',
  },
  NCL: {
    dealPageImageId: '41999qr5nijy8peoowsb',
    dealPageColour: '#3D78A6',
    finePrintLink: 'https://www.ncl.com/about/terms-and-conditions-au',
    refundPolicyLink: 'https://www.ncl.com/au/en/about/terms-and-conditions-au#!#cancellation',
    onlineCheckinLink: 'https://www.ncl.com/au/en/',
  },
  OCL: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#007BC3',
    finePrintLink: 'https://www.oceaniacruises.com/legal',
    refundPolicyLink: 'https://www.oceaniacruises.com/legal/ticket-contract',
    onlineCheckinLink: 'http://www.oceaniacruises.com',
  },
  PCL: {
    dealPageImageId: 'zl930hjir5ftsfo4bq9',
    dealPageColour: '#22539F',
    finePrintLink: 'https://www.princess.com/en-int/legal/passage-contract',
    onlineCheckinLink: 'https://www.princess.com/plan/oceanready/',
  },
  RCC: {
    dealPageImageId: 'rlj9duk389lbgI7m1wt',
    dealPageColour: '#23305C',
    finePrintLink: 'https://www.royalcaribbean.com/guest-terms/',
    refundPolicyLink: 'https://www.royalcaribbean.com/aus/en/faq/questions/booking-cancellation-refund-policy',
    onlineCheckinLink: 'https://www.royalcaribbean.com/account',
  },
  RDC: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#363A45',
    finePrintLink: 'https://www.rssc.com/legal/terms-conditions',
    onlineCheckinLink: 'https://www.rssc.com/',
  },
  SBN: {
    dealPageImageId: 'c95uaj6gcs0im2a6m8vm',
    dealPageColour: '#9D8C50',
    finePrintLink: 'https://www.seabourn.com/en/legal-privacy/cruise-contract',
    onlineCheckinLink: 'https://book2.seabourn.com/olci-iu/#/findBooking',
  },
  VVG: {
    dealPageImageId: 'vhq1kat09swfmb8zckv',
    dealPageColour: '#760504',
    finePrintLink: 'https://www.virginvoyages.com/addl-terms-and-conditions',
    onlineCheckinLink: 'https://www.virginvoyages.com/app',
  },
  SRX: {
    dealPageImageId: 'fn03fsdp8w7est4h62u',
    dealPageColour: '#4E5560',
    finePrintLink: 'https://www.silversea.com/terms-and-conditions.html',
    onlineCheckinLink: 'https://my.silversea.com/',
  },
  URC: {
    dealPageImageId: 'tjbk470qg2yfjr5rvsn',
    dealPageColour: '#3B5998',
    finePrintLink: 'https://www.uniworld.com/au/terms-and-conditions',
    onlineCheckinLink: 'https://www.uniworld.com/au/already-booked/express-check-in',
  },
  VOC: {
    dealPageImageId: 'zbvb1v1j7wb5blh02b',
    dealPageColour: '#241F21',
    finePrintLink: 'https://www.vikingcruises.com.au/legal',
    onlineCheckinLink: 'https://www.vikingcruises.com.au/oceans/my-trip/index.html',
  },
  VXP: {
    dealPageImageId: 'zbvb1v1j7wb5blh02b',
    dealPageColour: '#241F21',
    finePrintLink: 'https://www.vikingcruises.com.au/legal',
    onlineCheckinLink: 'https://www.vikingcruises.com.au/oceans/my-trip/index.html',
  },
  VRX: {
    dealPageImageId: 'o35itp7gl9xizeu7r8x',
    dealPageColour: '#241F21',
    finePrintLink: 'https://www.vikingcruises.com.au/legal',
    onlineCheckinLink: 'https://www.vikingcruises.com.au/oceans/my-trip/index.html',
  },
}

export const DEFAULT_CRUISE_LINE_DEALS_PAGE_INFO = CRUISE_LINE_INFO.CEL

export const SKIP_STEP_FOR_CABIN_TYPES: ReadonlyArray<string> = [CRUISE_CABIN_CATEGORY.SUITE]

export const CRUISE_ROUTES = {
  SEARCH_PAGE: '/search/cruises',
}

export const DEFAULT_CRUISE_LINE_FINE_PRINT_LINK = 'https://luxuryescapes.com/au/booking-policies#cruises'

export const CRUISE_AMENITY_CATEGORIES_REGEX = {
  FOOD: /food|buffet/,
  DINING: /dining|restaurant|cuisine|wine|cafe/,
  ENTERTAINMENT: /entertainment|show|nightlife|club|theater|music|movie|performance/,
  WELLNESS: /spa|wellness|health|relax|fitness|gym/,
  FAMILY: /kids|teens|family|youth|children/,
  ACTIVITIES: /activity|activities|adventure|recreation|sports|pool|water|swim|game|fun|arcade/,
  BARS: /bar|lounge|cocktail|drinks|pub/,
  SHOPPING: /shop|shopping|boutique|gallery|store/,
  TECHNOLOGY: /technology|tech|innovation/,
  ACCOMMODATION: /suite|stateroom|room|cabin/,
  ENRICHMENT: /enrich|educa|lecture|course/,
  SPECIFICATIONS: /ship fact|specification|tonnage|length|crew|passenger capacity|speed/,
  SERVICES: /service|staff|personal|butler|concierge/,
  PUBLIC_AREAS: /public area|common area|reception|atrium|lobby/,
  OTHER: /other/,
}
